import { SET_CREDENTIAL } from './types.js'

export default {
    [SET_CREDENTIAL] (state , payload) {
        state[payload.field] = payload.value
    }
}